// extracted by css-extract-rspack-plugin
export default {"input":"eyllEJ"};